'use client'

import { useRef, useState } from 'react'
import { IoMdSearch, IoMdClose } from 'react-icons/io'
import { useDebouncedCallback } from 'use-debounce'
import { useSearchParams } from 'next/navigation'

const TextSearch = ({ placeholder }: { placeholder?: string }) => {
  const searchParams = useSearchParams()
  const searchInput = useRef<HTMLInputElement>(null)
  const [isSearchPopupOpen, setIsSearchPopupOpen] = useState(false)

  const handleSearch = useDebouncedCallback((term) => {
    const params = new URLSearchParams(searchParams)
    params.set('page', '1')
    if (term) {
      params.set('keyword', term)
    } else {
      searchInput.current!.value = ''
      params.delete('keyword')
    }

    window.history.replaceState(null, '', `?${params.toString()}`)

  }, 500)

  const renderSearchInput = () => (
    <div className="relative">
      <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
        <IoMdSearch />
      </div>
      <input
        type="search"
        id="search"
        defaultValue={searchParams.get('keyword')?.toString()}
        ref={searchInput}
        onChange={(event) => handleSearch(event.target.value)}
        className="block w-full ps-10 text-sm placeholder-gray-500 border-gray-300 rounded-lg focus:ring-gray-300 focus:border-gray-300"
        placeholder={placeholder ? placeholder : 'Find a Hackathon'}
      />
    </div>
  )

  const renderSearchButton = () => (
    <button onClick={() => setIsSearchPopupOpen(!isSearchPopupOpen)} className="border rounded-lg p-2">
      <IoMdSearch className="text-2xl" />
    </button>
  )

  const renderSearchPopup = () => (
    <div className="fixed inset-0 bg-white p-4 z-50">
      <div className="flex items-center justify-between mb-3">
        <span>Search</span>
        <button onClick={() => setIsSearchPopupOpen(!isSearchPopupOpen)}>
          <IoMdClose />
        </button>
      </div>
      {renderSearchInput()}
    </div>
  )

  return (
    <>
      {/* Mobile view: TextSearch button */}
      <div className="sm:hidden flex items-center relative">
        {renderSearchButton()}
      </div>

      {/* Mobile view: TextSearch popup */}
      {isSearchPopupOpen && renderSearchPopup()}

      {/* Desktop view: Search input */}
      <div className="hidden sm:flex items-center relative">
        {renderSearchInput()}
      </div>
    </>
  )
}

export default TextSearch
